import { Box } from "@mui/material";
import React from "react";

import ContactForm from "../../components/ContactForm";
import Nav from "../../components/navComponents/Nav";

import { theme } from "../../utils/theme";

const ContactPage = () => {
  return (
    <Box sx={{ backgroundColor: theme.palette.grays[100] }}>
      <Nav contained={true} />

      <ContactForm />
    </Box>
  );
};

export default ContactPage;
